import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Label } from 'reactstrap';
import { TextField } from '@material-ui/core';
import CrearSolicitudButton from '../../../components/buttons/crearSolicitudButton';
import CrearUsuario from '../../../components/buttons/crearUsuario';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from 'react-loaders'

//Redux
import { connect } from 'react-redux';

//API Calls
// const {  } = require('../../utils/APIs/APISResume')

const mapStateToProps = state => ({
    usuarioActivo: state
})

const axios = require('axios')

let BodyCreateGroup = (props) => {
    const [mailList, setMailList] = useState([]);
    const [groupName, setGroupName] = useState('');

    const handleMailList = (list) => {
        const tempList = list.split(',');
        setMailList(tempList);
    }

    const handleCreate = async () => {
        const body = {
            cod_empr: 537,
            nombre: groupName,
            correos: mailList
        }
        await props.onClick(body);     
    }

    return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='12' md='12' xs="12">
                        <TextField
                            required
                            variant='outlined'
                            key={`key_name`}
                            id={`input_name`}
                            fullWidth
                            label='Nombre del Grupo'
                            margin="normal"
                            onChange={(e) => { setGroupName(e.target.value) }}
                        />
                    </Col>
                    <Col lg='12' md='12' xs="12">
                        <Label for="exampleSelect">Lista de correos</Label>
                        <Input
                            id="list"
                            key={`key_list`}
                            name="List"
                            type="textarea"
                            placeholder='Ingrese la lista de correos separados por coma (,).'
                            onChange={(e) => { handleMailList(e.target.value) }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg='12' md='12' xs="12" className='user-create-button'>
                    <CrearUsuario
                        onClick={(e) => { handleCreate(e) }} 
                        disabled={false}
                        tittle='Crear'
                    />
                        {/* <CrearSolicitudButton
                            onClick={(e) => { handleCreate(e) }} /> */}
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyCreateGroup);